import { lazy, useState } from "react";
import ButtonCom from "../../components/button/button";
import { Form } from "react-bootstrap";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import makeAnimated from "react-select/animated";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";

const Earning = lazy(() => import("./Details/Earning"));
const Compliance = lazy(() => import("./Details/Compliance"));
const Deduction = lazy(() => import("./Details/Deduction"));

const SalaryDetails = () => {
  const [deductions, setDeductions] = useState([]);

  const [earnings, setEarnings] = useState([
    {
      id: "basic1",
      head: "Basic",
      calculation: "basic",
    },
    {
      id: "hra1",
      head: "HRA",
      calculation: "hra",
    },
    {
      id: "dearness1",
      head: "Dearness Allowance",
      calculation: "dearness",
    },
  ]);

  const addEarningField = (e) => {
    const { value, label } = e;
    setEarnings([
      ...earnings,
      {
        id: value,
        head: label,
        calculation: "",
      },
    ]);
  };

  const removeEarningFields = (e, index) => {
    e.preventDefault();
    const rows = [...earnings];
    rows.splice(index, 1);
    setEarnings(rows);
  };

  const handleEarningChanges = (index, e) => {
    const { name, value } = e.target;
    const list = [...earnings];
    list[index][name] = value;
    setEarnings(list);
  };

  const [saveCompliances, setSaveCompliances] = useState({
    designationName: "",
    contributes: [],
  });

  const handleComplianceChange = (e) => {
    setSaveCompliances({
      ...saveCompliances,
      compliances: e,
    });
  };

  const addDeductionsField = (e) => {
    const { value, label } = e;
    setDeductions([
      ...deductions,
      {
        id: value,
        head: label,
        calculation: "",
      },
    ]);
  };

  const removeDeductionsFields = (e, index) => {
    e.preventDefault();
    const rows = [...deductions];
    rows.splice(index, 1);
    setDeductions(rows);
  };

  const handleDeductionsChanges = (index, e) => {
    const { name, value } = e.target;
    const list = [...deductions];
    list[index][name] = value;
    setDeductions(list);
  };

  const preSubmit = () => {
    document.getElementById("submitForm").click();
  };

  return (
    <div className="body-container">
      <div className="page-top-bar">
        <div style={{ display: "flex", alignItem: "center", justifyContent: "start", gap: "10px" }}>
          <Link to={"/setting/"}>
            <ArrowBackIcon sx={{ scale: 1 }} style={{ color: "gray" }} />
          </Link>
          <h1 style={{ fontSize: "20px", fontWeight: "400" }}>Salary Details Import Settings</h1>
        </div>

        <ButtonCom
          type={"button"}
          class_name={"p_btn"}
          text="Save Details"
          url_or_onclick={() => { }}
          icon={null}
          width={""}
        />
      </div>
      <div className="page-body p-5">
        <Form
          onSubmit={preSubmit}
          id="submitForm"
        >
          <Earning
            earnings={earnings}
            addField={addEarningField}
            removeFields={removeEarningFields}
            handleChanges={handleEarningChanges}
          />
          <Compliance onChange={handleComplianceChange} />
          <Deduction
            deductions={deductions}
            addField={addDeductionsField}
            removeFields={removeDeductionsFields}
            handleChanges={handleDeductionsChanges}
          />
        </Form>
      </div>
    </div>
  );
};

export default SalaryDetails;
